<template>
  <div>
    <b-modal
        v-model="modalVisible"
        id="modal-login"
        centered
        ref="enderecoModal"
        title="Endereço"
        :ok-title="type === 'adicionar' ? 'Adicionar' : 'Atualizar'"
        :ok-disabled="type === 'visualizar' || !formIsValid"
        cancel-variant="outline-secondary"
        cancel-title="Cancelar"
        @hidden="resetModal"
        @ok="handleOk"
    >
      <validation-observer ref="enderecoForm" v-slot="{ valid }" slim>
        <b-form>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="sequencial">SEQUENCIAL</label>
                <b-form-input
                    id="sequencial"
                    type="text"
                    placeholder="Sequencial"
                    v-model="endereco.clienteEnderecoseq"
                    :disabled="type === 'visualizar' || type === 'atualizar' || type === 'adicionar'"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="tipoEndereco">TIPO ENDEREÇO</label>
                <validation-provider name="Tipo Endereço" rules="required" v-slot="{ errors }">
                  <b-form-select
                      id="tipoEndereco"
                      :options="options"
                      v-model="endereco.tipoEnderecoid"
                      :disabled="type === 'visualizar' || type === 'atualizar'"
                      :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label for="cep">CEP</label>
                <validation-provider name="CEP" rules="required" v-slot="{ errors }">
                  <b-form-input
                      id="cep"
                      type="text"
                      placeholder="CEP"
                      v-mask="'#####-###'"
                      v-model="endereco.clienteenderecocep"
                      :disabled="type === 'visualizar'"
                      :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="rua">RUA</label>
                <validation-provider name="Rua" rules="required|alpha" v-slot="{ errors }">
                  <b-form-input
                      id="rua"
                      type="text"
                      placeholder="Rua"
                      v-model="endereco.clienteendereco"
                      :disabled="type === 'visualizar'"
                      :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label for="bairro">BAIRRO</label>
                <validation-provider name="Bairro" rules="required|alpha" v-slot="{ errors }">
                  <b-form-input
                      id="bairro"
                      type="text"
                      placeholder="Bairro"
                      v-model="endereco.clienteenderecobairro"
                      :disabled="type === 'visualizar'"
                      :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="pais">PAÍS</label>
                <validation-provider name="País" rules="required" v-slot="{ errors }">
                  <b-form-select
                      id="pais"
                      :options="optionsPais"
                      v-model="endereco.paisid"
                      :disabled="type === 'visualizar'"
                      :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label for="numero">NÚMERO</label>
                <validation-provider name="Número" rules="required|numeric" v-slot="{ errors }">
                  <b-form-input
                      id="numero"
                      type="text"
                      placeholder="Número"
                      v-model="endereco.clienteendereconumero"
                      :disabled="type === 'visualizar'"
                      :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="complemento">COMPLEMENTO</label>
                <b-form-input
                    id="complemento"
                    type="text"
                    placeholder="Complemento"
                    v-model="endereco.clienteenderecocomplemento"
                    :disabled="type === 'visualizar'"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group>
                <label for="estado">ESTADO</label>
                <validation-provider name="Estado" rules="required" v-slot="{ errors }">
                  <b-form-select
                      id="estado"
                      :options="optionsEstados"
                      v-model="endereco.ufid"
                      :disabled="type === 'visualizar'"
                      :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="cidade">CIDADE</label>
                <validation-provider name="Cidade" rules="required|alpha" v-slot="{ errors }">
                  <b-form-input
                      id="cidade"
                      type="text"
                      placeholder="Cidade"
                      v-model="endereco.clienteenderecocidade"
                      :disabled="type === 'visualizar'"
                      :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group>
                <label for="observacoes">OBSERVAÇÕES</label>
                <b-form-input
                    id="observacoes"
                    type="text"
                    placeholder="Observações"
                    v-model="endereco.clienteenderecoobservacoes"
                    :disabled="type === 'visualizar'"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BFormSelect,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import Ripple from 'vue-ripple-directive';
import PTC_CadastroClienteService from '@/services/PTC/PTC_CadastroCliente.service';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, numeric, alpha } from '@validations';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';

const ptc_CadastroClienteService = new PTC_CadastroClienteService();
export default {
  components: {
    BFormSelect,
    BButton,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      type: '',
      modalVisible: false,
      isProcessing: false,
      options: ['COBRANCA', 'ENTREGA', 'PADRAO'],
      optionsPais: [{ value: 1, text: 'Brasil' }, { value: 2, text: 'Argentina' }],
      optionsEstados: [{ value: 1, text: 'São Paulo' }, { value: 2, text: 'Rio de Janeiro' }],
      formIsValid: false,
      endereco: {
        clienteEnderecoseq: 0,
        tipoEnderecoid: '',
        clienteenderecocep: '',
        clienteendereco: '',
        clienteenderecobairro: '',
        paisid: '',
        clienteendereconumero: '',
        clienteenderecocomplemento: '',
        ufid: '',
        clienteenderecocidade: '',
        clienteenderecoobservacoes: '',
      },
    };
  },
  methods: {
    show(tipoOperacao, dados = null) {
      console.log('tipoOperacao', tipoOperacao, 'dados', dados);
      this.type = tipoOperacao;
      this.isProcessing = false;

      if (tipoOperacao === 'atualizar' || tipoOperacao === 'visualizar') {
        this.endereco = { ...dados };
        if (tipoOperacao === 'visualizar') {
          this.formIsValid = true;
        } else {
          this.$nextTick(() => {
            this.checkFormValidity();
          });
        }
      } else {
        this.endereco = {
          clienteEnderecoseq: 1,
          tipoEnderecoid: 'COBRANCA',
          clienteenderecocep: '',
          clienteendereco: '',
          clienteenderecobairro: '',
          paisid: '',
          clienteendereconumero: '',
          clienteenderecocomplemento: '',
          ufid: '',
          clienteenderecocidade: '',
          clienteenderecoobservacoes: '',
        };
        this.$nextTick(() => {
          this.checkFormValidity();
        });
      }

      this.modalVisible = true;
    },
    async checkFormValidity() {
      if (this.type === 'visualizar') {
        this.formIsValid = true;
        return;
      }

      if (this.$refs.enderecoForm) {
        const isValid = await this.$refs.enderecoForm.validate();
        this.formIsValid = isValid;
      }
    },
    resetModal() {
      this.endereco = {
        clienteEnderecoseq: 1,
        tipoEnderecoid: 'COBRANCA',
        clienteenderecocep: '',
        clienteendereco: '',
        clienteenderecobairro: '',
        paisid: '',
        clienteendereconumero: '',
        clienteenderecocomplemento: '',
        ufid: '',
        clienteenderecocidade: '',
        clienteenderecoobservacoes: '',
      };
      this.formIsValid = false;
      this.isProcessing = false;

      this.$nextTick(() => {
        if (this.$refs.enderecoForm) {
          this.$refs.enderecoForm.reset();
        }
      });
    },
    handleOk(bvModalEvt) {
      if (this.isProcessing) {
        bvModalEvt.preventDefault();
        return;
      }

      bvModalEvt.preventDefault();
      this.validateForm();
    },
    async validateForm() {
      if (this.isProcessing) {
        return;
      }

      const isValid = await this.$refs.enderecoForm.validate();
      this.formIsValid = isValid;

      if (!isValid) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro de validação',
            text: 'Por favor, preencha todos os campos obrigatórios.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
        return;
      }

      this.handleSubmit();
    },
    async handleSubmit() {
      if (this.isProcessing) {
        return;
      }

      this.isProcessing = true;

      try {
        if (this.type === 'adicionar') {
          await this.createEndereco();
        }
        if (this.type === 'atualizar') {
          await this.updateEndereco();
        }

        await ptc_CadastroClienteService.RetornaEnderecoCliente();

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: this.type === 'adicionar' ? 'Endereço adicionado com sucesso!' : 'Endereço atualizado com sucesso!',
            icon: 'CheckCircleIcon',
            variant: 'success',
          },
        });

        this.modalVisible = false;
      } catch (error) {
        console.error('Erro ao processar endereço:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Ocorreu um erro ao processar o endereço.',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.isProcessing = false;
      }
    },
    async createEndereco() {
      const response = await ptc_CadastroClienteService.CreateEnderecoCliente(this.endereco);
      console.log('response', response);
    },
    async updateEndereco() {
      const response = await ptc_CadastroClienteService.UpdateEnderecoCliente(this.endereco);
      console.log('response', response);
    },
  },
  watch: {
    endereco: {
      deep: true,
      handler() {
        if (this.isProcessing) {
          return;
        }

        this.$nextTick(() => {
          this.checkFormValidity();
        });
      },
    },
    type(val) {
      if (val === 'visualizar') {
        this.formIsValid = true;
      }
    },
  },
};
</script>
